import React from "react";
import "../../Styles/certified/vmg.css";

export default function Finzly() {
  return (
    <>
      <div className="vmg-certified-details-section">
        <div className="vmg-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="vmg-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="vmg-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="vmg-certified-badge"
            />
            <div className="vmg-certified-company-names">
              <a href="https://go.vmg-connect.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/vmg/vmg.png"
                alt="Walkzero Logo"
                className="vmg-certified-company-logo"
              />
            </a>
              <h1 className="vmg-certified-full-name">
              VMG Group Services India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="vmg-certified-details-right">
            <img
              src="/assets/vmg/vm_4.jpeg"
              alt="Finzly Office"
              className="vmg-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="vmg-certified-description">
          <h2>
            Why  vmg Services Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           VMG Group (Velocity Made Good)  
Founded in 2007 by entrepreneurs Doug Drury and Jonathan Reid, The VMG Group (Velocity Made Good) is a privately owned global portfolio of technology, services, and product businesses. With operations spanning North America, Europe, Asia, and Oceania, VMG delivers innovative solutions at the intersection of creativity, technology, and retail transformation.


          </p>
          <p>
            The Group comprises four specialized businesses:

VMG Digital – delivering social-first creative and content solutions.
VMG Premedia – enabling scalable print and digital production workflows.
Red Pepper Digital – driving retail technology and digital commerce innovation.
VMG Connect – providing technology consulting and transformation services.

          </p>
          <p>
            Powered by a diverse global workforce and strategic delivery hubs in India and the Philippines, VMG combines creativity, operational excellence, and technology expertise to support leading brands worldwide. Its collaborative culture, commitment to innovation, and people-first approach enable the organization to deliver high-quality, scalable solutions while fostering an environment where employees can grow, contribute, and thrive.
          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="vmg-certified-info-cards">
          <div className="vmg-certified-info-card">
            <div className="vmg-certified-info-title">COMPANY SIZE</div>
            <div className="vmg-certified-info-value">240 Employees</div>
          </div>
          <div className="vmg-certified-info-card">
            <div className="vmg-certified-info-title">INDUSTRY</div>
            <div className="vmg-certified-info-value">KTO

</div>
          </div>
          <div className="vmg-certified-info-card">
            <div className="vmg-certified-info-title">CONNECT</div>
            <div className="vmg-certified-info-icons">
              <span className="vmg-certified-icon-round">
                <a href="https://go.vmg-connect.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="vmg-certified-icon-round">
                <a href="https://www.linkedin.com/showcase/vmgconnect/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="vmg-certified-icon-round">
                <a href="https://www.facebook.com/vmgdigitalcreativeagency#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="vmg-certified-info-card">
            <div className="vmg-certified-info-title">LOCATION (HQ)</div>
            <div className="vmg-certified-info-value">Chennai </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="vmg-certified-recognition-section">
          <h2 className="vmg-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="vmg-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="vmg-certified-recognition-image"
            />
          </div>
          <div className="vmg-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="vmg-certified-life-section">
          <h2 className="vmg-certified-life-title">
            Life at vmg Services Private Limited
          </h2>
          <div className="vmg-certified-life-gallery">
            <div className="vmg-certified-life-col">
              <img src="/assets/vmg/vm_1.jpeg" alt="Office 1" className="vmg-certified-life-img" />
              <img src="/assets/vmg/vm_2.jpeg" alt="Team 1" className="vmg-certified-life-img" />
            </div>
            <div className="icom-certified-life-col vmg-certified-life-center">
              <img src="/assets/vmg/vm_6.jpeg" alt="Main Office" className="vmg-certified-life-img vmg-certified-life-img-large" />
            </div>
            <div className="vmg-certified-life-col">
              <img src="/assets/vmg/vm_3.jpeg" alt="Office 2" className="vmg-certified-life-img" />
              <img src="/assets/vmg/vm_7.jpeg" alt="Team 2" className="vmg-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
